export default __webpack_public_path__ + "decrease-indent.f13ab952dbc2ab3b.svg";